'use client';

import classNames from 'classnames';
import { ExpandedRevealingPoints } from '@sapientpro/sapientpro-data-models';
import styles from './SideRevealingPointsSection.module.scss';
import AnimatedTitle from '../AnimatedTitle';
import SideRevealingPoints from './SideRevealingPoints';

type SideRevealingPointsSectionProps = {
  data: ExpandedRevealingPoints;
};

const SideRevealingPointsSection = ({
  data,
}: SideRevealingPointsSectionProps) => (
  <section className={classNames(styles.sideRevealingPointsSection, 'container')}>
    <h2 className={classNames(styles.sideRevealingPointsSection__title, 'header2')}>
      <AnimatedTitle title={data.title} />
    </h2>
    <SideRevealingPoints
      points={data.points}
    />
  </section>
);

export default SideRevealingPointsSection;
